// eslint-disable-next-line no-unused-vars
const FUTURES_COMMAND_PKG = {
    navTitle: "Futures",
    routerName: "FuturesDocs",
    commandsDescription: "SPY, DOW, Oil, etc...",

    commandList: [
        {
            title: "Dow Futures",
            routerRef: "ym",
            commandString: "!ym",
            description: "DOW Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!ym"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Spy Futures",
            routerRef: "es",
            commandString: "!es",
            description: "Spy Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!es"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Russel Futures",
            routerRef: "rut",
            commandString: "!rut",
            description: "Russel Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!rut"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "US Major Futures",
            routerRef: "futures",
            commandString: "!futures",
            description: "All US Major Futures",
            parameters: ["none"],
            examples: [
                "!futures"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "World Futures",
            routerRef: "worldfutures",
            commandString: "!worldfutures",
            description: "All Major World Futures",
            parameters: ["none"],
            examples: [
                "!worldfutures"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Dollar Futures",
            routerRef: "dollarfutures",
            commandString: "!dxy",
            description: "Dollar Futures",
            parameters: ["none"],
            examples: [
                "!dxy"
            ],
            type: "Futures",
            shortcuts: ["none"]
        },
        {
            title: "VIX Futures",
            routerRef: "vix",
            commandString: "!vix",
            description: "Vix Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!vix"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Silver Futures",
            routerRef: "si",
            commandString: "!si",
            description: "Silver Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!si"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Oil Futures",
            routerRef: "cl",
            commandString: "!cl",
            description: "Oil Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!cl"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Nickel Futures",
            routerRef: "ni",
            commandString: "!ni",
            description: "Nickel Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!ni"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Nikkei Futures",
            routerRef: "nik",
            commandString: "!nik",
            description: "Nikkei Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!nik"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "NAS Futures",
            routerRef: "nas",
            commandString: "!nas",
            description: "NAS Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!nas"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "FTSE Futures",
            routerRef: "ftse",
            commandString: "!ftse",
            description: "FTSE Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!ftse"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "CAC Futures",
            routerRef: "cac",
            commandString: "!cac",
            description: "CAC Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!cac"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Gold Futures",
            routerRef: "gc",
            commandString: "!gc",
            description: "Gold Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!gc"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Oil Futures",
            routerRef: "cl",
            commandString: "!cl",
            description: "Oil Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!cl"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "CSI (Shanghai) 300 Futures",
            routerRef: "csi",
            commandString: "!csi",
            description: "CSI (Shanghai) 300 Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!csi"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "DAX Futures",
            routerRef: "dax",
            commandString: "!dax",
            description: "DAX Futures - Price - No Chart",
            parameters: ["none"],
            examples: [
                "!dax"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Top Futures",
            routerRef: "topfutures",
            commandString: "!topfutures",
            description: "Top 10 futures",
            parameters: ["none"],
            examples: [
                "!topfutures"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
        {
            title: "Bottom Futures",
            routerRef: "botfutures",
            commandString: "!botfutures",
            description: "Bottom 10 futures",
            parameters: ["none"],
            examples: [
                "!botfutures"
            ],
            type: "Futures", 
            shortcuts: ["none"]
        },
    ]
}


export {FUTURES_COMMAND_PKG};